import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'reactstrap'
import dayjs from 'dayjs'
import { TaxReturnTileContainer } from '../tax-return-tile-container'
import { statusMap } from './status-map'

export function TaxReturnTile (props) {
  window.sessionStorage.removeItem('transactionData')
  window.sessionStorage.removeItem('boxNumber')
  let status = (props.isReconciliation) ? statusMap[props.reconciliationStatus] : statusMap[props.status]
  const startDate = new Date(props.startDate)
  const finishDate = new Date(props.finishDate)
  const isDisabled = (props.status === 'Submission in progress') || false
  let url = null
  if (status === undefined) {
    status = {
      color: 'info',
      icon: 'no-icon'
    }
  }
  if (props.isAudit) {
    url = `/audit/summary?taxreturn=${props.id}&taxregistration=${props.taxRegistrationId}`
  } else if (props.isReconciliation) {
    url = `/reconciliation/summary?reconciliation=${props.reconciliationId}&registration=${props.registrationNumber}&status=unsubmitted&taxregistration=${props.taxRegistrationId}
    &registeredName=${props.registeredName}`
  } else if (props.status === 'Pending approval') {
    url = `summary/approve?taxReturn=${props.id}`
  } else if (props.status === 'Awaiting Imports') {
    url = `summary/imports-parts?taxReturn=${props.id}&registration=${props.registrationNumber}`
  } else if (props.status === 'Awaiting reconciliation') {
    url = `/reconciliation/summary?reconciliation=${props.reconciliationId}&registration=${props.registrationNumber}
    &registeredName=${props.registeredName}&status=unsubmitted&taxregistration=${props.taxRegistrationId}`
  } else {
    url = `/summary?taxReturn=${props.id}`
  }
  return (
    <TaxReturnTileContainer>
      <mosaic-card class='p-3 p-lg-4 border-0'>
        <div className='mb-2'>
          <mosaic-card-header card-header-subtitle='Tax registration number' class='mb-0 p-0'></mosaic-card-header>
          <span>{props.registrationNumber}</span>
        </div>
        <div className='mb-2'>
          <Button color={status.color} href={url} className={`btn-icon-large border-0 p-2 d-block ${status.color === 'warning' ? '' : ' text-white'}`} disabled={isDisabled}>
            <div>
              <svg className='icon m-0'>
                <use xlinkHref={status.icon} href={status.icon}></use>
              </svg>
            </div>
            <span>{props.isReconciliation ? props.reconciliationStatus : props.status}</span>
            <span className='sr-only'>{props.registrationNumber}</span>
          </Button>
        </div>
        {!props.isReconciliation &&
        <div>
          <p className='mb-0'>Date</p>
          <span>{dayjs(startDate).format('DD/MM/YYYY')} - {dayjs(finishDate).format('DD/MM/YYYY')}</span>
          {!props.isAudit && !['Submitted', 'Submission in progress', 'Submission failed'].includes(props.status) && (props.isAdmin || props.isApprover) &&
            <mosaic-button size='sm' outline color='danger' class='float-right' icon='delete_sign' onClick={() => props.deleteReturn(props.id)}>Delete</mosaic-button>
          }
        </div>}
      </mosaic-card>
    </TaxReturnTileContainer>
  )
}

TaxReturnTile.propTypes = {
  registrationNumber: PropTypes.string,
  id: PropTypes.string,
  status: PropTypes.string,
  registeredName: PropTypes.string,
  startDate: PropTypes.string,
  finishDate: PropTypes.string,
  isAudit: PropTypes.bool,
  isReconciliation: PropTypes.bool,
  taxRegistrationId: PropTypes.string,
  reconciliationId: PropTypes.string,
  reconciliationStatus: PropTypes.string,
  deleteReturn: PropTypes.func,
  isAdmin: PropTypes.bool,
  isApprover: PropTypes.bool
}
